export function parseUrlData() {
    const path = window.location.pathname; 
    const regex = /^\/([^/]+)\/([^/]+)\/?/;
    const match = path.match(regex);
  
    if (match) {
      const language = match[1];
      const partner = match[2];
      return { language, partner };
    }
  
    return { language: null, partner: null };
  }